<template>
    <el-dialog
        :visible="isVisible"
        @close="hide"
        title="Export conversation"
        :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <form-export
            v-if="isInitialized"
            v-bind="formData"
            @stored="onStored"
        ></form-export>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';
  import FormExport from '../../components/conversations/form-export';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      FormExport,
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
      }
    },

    created() {
      eventBus.$on('show-export-conversion-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-export-conversion-dialog', this.show);
    }
  }
</script>
